<template>
    <CModal
        title="Поставить в стоп"
        :show.sync="open"
        :footer="false"
        color="info"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm>
                    <CRow class="pl-3 mb-1">Поставить ресторан в стоп с нынешнего времени, до:</CRow>
                    <CRow>
                        <CCol>
                            <CInput
                                v-model="stopTime"
                                class="m-0"
                                type="time" />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('stop-modal-close')"
                >Отмена</CButton
                >
                <CButton
                    color="danger"
                    class="ml-3"
                    @click="resetStop"
                >Сбросить</CButton
                >
                <CButton
                    color="primary"
                    class="ml-3"
                    @click="setStop"
                >Приостановить</CButton
                >
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'StopServiceModal',

        props: {
            open: {
                type: Boolean,
                default: false
            },
            id: {
                type: [Number, String],
                default: null
            },
            type: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                isAuthorized: false,
                stopTime: null,
                inStop: null,
                url: '',
            };
        },

        computed: {},

        mounted() {
            this.stopTime = new Date().toLocaleTimeString().slice(0, 5);

            switch (this.type) {
            case BUSINESS_TYPE.RESTAURANT:
                this.url = `/restaurants/stop/${this.id}`;
                break;
            case BUSINESS_TYPE.GROCER:
                this.url = `/grocers/stop/${this.id}`;
                break;
            case BUSINESS_TYPE.PHARMACY:
                this.url = `/pharmacies/stop/${this.id}`;
                break;
            case BUSINESS_TYPE.ASSISTANT:
                this.url = `/assistants/stop/${this.id}`;
                break;
            case BUSINESS_TYPE.ENTITY:
                this.url = `/entities/stop/${this.id}`;
                break;
            
            default: return;
            }
        },

        methods: {
            async setStop() {
                const [hours, minutes] = this.stopTime.split(':');
                const dateToStop = new Date(new Date().setHours(hours, minutes));
                const now = new Date();

                if (dateToStop.getTime() <= now.getTime()) {
                    this.$root.$emit('showError', 'Время не может быть выбрано меньше нынешнего.');
                    return;
                }

                try {
                    const newSchedule = await Vue.axios
                        .post(this.url, { stop_until: moment(dateToStop).format('YYYY-MM-DD HH:mm:ss') });
                    if (newSchedule.data.workingHours.length != 0) {
                        this.$emit('stop-modal-update', newSchedule.data.workingHours);
                    }
                    // if (newSchedule.data.schedule.length != 0) {
                    //     this.$emit('stop-modal-update', newSchedule.data.schedule);
                    // }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.' + err);
                }
                this.$emit('stop-modal-close');
            },
            async resetStop() {
                try {
                    const newSchedule = await Vue.axios.post(this.url, { stop_until: null });
                    if (newSchedule.data.schedule.length != 0) {
                        this.$emit('stop-modal-update', newSchedule.data.schedule);
                    }
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
                }
                this.$emit('stop-modal-close');
            },
        },
    };
</script>
